import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs'
import { BehaviorSubject } from 'rxjs';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';
import { NgForm, FormsModule } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';

@Component({
  selector: 'app-evaluatevendor',
  templateUrl: './evaluatevendor.component.html',
  styleUrls: ['./evaluatevendor.component.css']
})
export class EvaluatevendorComponent implements OnInit {

  currentUserData: any;
  vendorData: any;
  vModelData: Vendordata;

  applicationRefNo: string;

  enlistmentStepsData : any;
  enlistmentStepsSorted : any = [];

  fapplicationNumber : string;
  fstepno :string;


  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorEvaluationService: EvaluationService,
    private enlistmentServices: EnlistmentService, private route: ActivatedRoute,
    private vendorDashboardService: VendordashboardService) {
    this.applicationRefNo = this.route.snapshot.params.applicationrefno;
  }

  ngOnInit() {

    this.fapplicationNumber = this.applicationRefNo;
    this.userService.currentUser.subscribe(
      (userdata) => {
        debugger;
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;

          this.vendorEvaluationService.getVendorData(this.applicationRefNo).subscribe(
            (data) => {
              this.vendorData = data;
              this.vModelData = this.vendorData;
              
              this.vendorDashboardService.getVendorEnlistmentSteps(this.vModelData.userId).subscribe(
                (enlistdata) => {
                  debugger;
                  
                  this.enlistmentStepsData = enlistdata;
                  console.log(this.enlistmentStepsData)
                  for (var i = 0; i < this.enlistmentStepsData.length; i++) {
                    //if(this.enlistmentStepsData.listTableName== "VendorData"){}
                    var index = this.enlistmentStepsData[i].stepNo;
                    this.enlistmentStepsData[i].urlFormName = "evaluate" + this.enlistmentStepsData[i].urlFormName;  
                    this.enlistmentStepsSorted[index] = this.enlistmentStepsData[i];
                  }
                  this.enlistmentStepsSorted.splice(0, 1);
                  this.fstepno = this.enlistmentStepsData.length + 1;
                }
              );

            }
          )
        }
      }
    );

  }

}
